import React, { forwardRef, useContext } from 'react';
import { SearchIcon } from './Icons';
import { SelectContext } from './SelectProvider';

const SearchInput = forwardRef(function SearchInput(
  { placeholder = '', value = '', onChange, name = '', onKeyDownSearch = () => {} },
  ref
) {
  const { classNames } = useContext(SelectContext);

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      onKeyDownSearch();
    }
  };

  return (
    <div
      className={
        classNames && classNames.searchContainer
          ? classNames.searchContainer
          : 'relative px-2.5 py-1'
      }
    >
      <SearchIcon
        className={
          classNames && classNames.searchIcon
            ? classNames.searchIcon
            : 'absolute ml-2 mt-2.5 h-5 w-5 pb-0.5 text-gray-900'
        }
      />
      <input
        ref={ref}
        className={
          classNames && classNames.searchBox
            ? classNames.searchBox
            : 'w-full rounded border border-gray-200 bg-gray-100 py-2 pl-8 text-sm text-gray-900 focus:border-gray-200 focus:outline-none focus:ring-0'
        }
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        onKeyDown={(val) => onKeyDown(val)}
      />
    </div>
  );
});

export default SearchInput;
